//Contact.js
import React from 'react';
import ContactForm from '../components/Contactform';
import '../assets/style/Contact.css'

const Contact = () => {
  return (
    <div className="sections">
      <ContactForm />
    </div>
  );
};

export default Contact;